import { AppForm, AppFormItem, formRules } from 'shared/UI/UIKit/Form';
import { AppInput } from 'shared/UI/UIKit/Input';
import { AppMultipleSelect } from 'shared/UI/UIKit/Select';
import type { TeacherWorkloadFormProps } from '../types';
import { validateSubjectRows } from '../lib/validateTeacherWorkloadForm';
import { validateWorkDaysSchedule } from '../lib/validateWorkDays';
import { useTeacherWorkloadForm } from '../model';
import { SubjectsTable, WorkDaysScheduleField } from './components';
import styles from './styles.module.scss';

export const TeacherWorkloadForm = ({
  form,
  availableSubjects,
  subjectsLoading,
  error,
  setError,
  initialDataSource,
  availableEducationClasses,
}: TeacherWorkloadFormProps) => {
  const {
    state: { rooms, subjectError },
  } = useTeacherWorkloadForm(error);
  return (
    <AppForm form={form}>
      <AppFormItem
        label="Код преподавателя"
        labelColor="gray"
        size="max"
        name="code"
        rules={formRules.required}
      >
        <AppInput placeholder="Например: Иванов И.И." />
      </AppFormItem>

      <AppFormItem
        label="Аудитория преподавателя"
        labelColor="gray"
        size="max"
        name="preferredRoomIds"
      >
        <AppMultipleSelect
          className={styles.preferredRooms}
          maxTagCount="responsive"
          options={rooms.map((room) => ({
            label: `${room.number} - ${room.name}`,
            value: room.id,
          }))}
          allowClear
        />
      </AppFormItem>

      <AppFormItem
        label="Рабочие дни"
        labelColor="gray"
        size="max"
        name="workDays"
        rules={[{ validator: validateWorkDaysSchedule }]}
      >
        <WorkDaysScheduleField />
      </AppFormItem>

      <SubjectsTable
        availableSubjects={availableSubjects}
        subjectsLoading={subjectsLoading}
        form={form}
        setError={setError}
        initialDataSource={initialDataSource}
        availableEducationClasses={availableEducationClasses}
      />

      {subjectError && <div style={{ color: 'red' }}>{subjectError}</div>}

      <AppFormItem name="subjectRows" rules={[{ validator: validateSubjectRows }]} hidden />
    </AppForm>
  );
};
